import React, { useState } from 'react'
import PropTypes from 'prop-types'

import AppsIcon from '@mui/icons-material/Apps'
import ListIcon from '@mui/icons-material/List'
import Button from '@mui/material/Button'
import { useLocation } from 'react-router-dom'

export default function DisplayMode({ objectModeDisplay, saveModeDisplaySetting }) {
  const location = useLocation()

  const getModeDisplay = () => {
    return objectModeDisplay ? objectModeDisplay[location.pathname] : false
  }
  const [on, setOnModeCard] = useState(getModeDisplay())
  const handleClick = () => {
    setOnModeCard(!on)
    objectModeDisplay = { ...objectModeDisplay, [location.pathname]: !on }
    saveModeDisplaySetting(objectModeDisplay)
  }

  return (
    <Button
      id="Tab-list"
      variant="contained"
      onClick={() => handleClick()}
      sx={{
        margin: '0px 8px',
        height: '33px',
        backgroundColor: 'white',
        minWidth: '50px',
        color: '#1976D2',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      {on ? <ListIcon /> : <AppsIcon />}
    </Button>
  )
}

DisplayMode.propTypes = {
  objectModeDisplay: PropTypes.object,
  saveModeDisplaySetting: PropTypes.func,
}
